import { motion } from 'framer-motion';

/**
 * CredibilityIcons Component
 * Props:
 * - items [{icon, title, description}]
 * Features:
 * - Horizontal scroll or flex wrap layout
 * - Animations: fade-in staggered
 * - Loose coupling: content defined via props
 */

const CredibilityIcons = ({ items = [] }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5 },
    },
  };

  return (
    <section className="py-12 bg-gray-50">
      <div className="container-custom">
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {items.map((item, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="flex flex-col items-center text-center p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <div className="text-secondary-500 text-4xl mb-4">
                {typeof item.icon === 'string' ? (
                  <img src={item.icon} alt={item.title} className="h-12 w-12 mx-auto" />
                ) : (
                  item.icon
                )}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-gray-600">
                {item.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default CredibilityIcons;

